import { OverlayTrigger } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/esm/Overlay';
import classNames from 'classnames';
import { PopoverTooltipV2 as PopoverTooltip } from '@praktio/common-ui';

import './IconTooltip.scss';

export type IconTooltipProps = {
  id: string;
  icon: string;
  placement?: Placement;
  title?: string;
  text: string;
  disabled?: boolean;
};

export type OptionalIconTooltipProps = Partial<IconTooltipProps>; // Makes all properties optional

const IconTooltip = ({
  id,
  icon,
  placement = 'left',
  title,
  text,
  disabled = false,
}: IconTooltipProps) => {
  const renderIcon = () => {
    return (
      <span
        className={classNames('IconTooltip__icon material-symbols-sharp', {
          'IconTooltip__icon--disabled': disabled,
        })}
      >
        {icon}
      </span>
    );
  };

  return (
    <div className="IconTooltip">
      {disabled ? (
        renderIcon()
      ) : (
        <OverlayTrigger
          placement={placement}
          overlay={<PopoverTooltip id={id} title={title} paragraph={text} />}
        >
          {renderIcon()}
        </OverlayTrigger>
      )}
    </div>
  );
};

export default IconTooltip;
